import { render, staticRenderFns } from "./MetadataConflictFilesList.vue?vue&type=template&id=87d2bd56&"
import script from "./MetadataConflictFilesList.vue?vue&type=script&lang=js&"
export * from "./MetadataConflictFilesList.vue?vue&type=script&lang=js&"
import style0 from "./MetadataConflictFilesList.vue?vue&type=style&index=0&id=87d2bd56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports